module.exports = __webpack_public_path__ + "img/aia-title-tips.924a004f.svg";